import React, { createContext, useContext } from 'react';
import { defaultPhrasierTheme } from './PhrasierTheme.js';
const ThemeContext = createContext(defaultPhrasierTheme);
export function ThemeProvider({ children, theme = defaultPhrasierTheme }) {
    return React.createElement(ThemeContext.Provider, { value: theme }, children);
}
export function useTheme() {
    return useContext(ThemeContext);
}
//# sourceMappingURL=ThemeProvider.js.map